import React, {useState, useEffect} from 'react';
import {labels} from '../../../../util/utils';
import Input from '../../../CoreWrappers/Input';
import Button from '../../../CoreWrappers/Button';
import {IconoirXmarkCircle} from '@ey-xd/motif-icon';
import styled from 'styled-components';

const AddNewDomain = (props) => {
	const {domains} = props;
	const [domainName, setDomainName] = useState('');
	const [showNameValidation, setShowNameValidation] = useState(false);
	const [duplicateValidation, setDuplicateValidation] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const [invalidValidation, setInvalidValidation] = useState(false);

	const onInputChange = (e) => {
		if (!e.target.value || e.target.value.length > 100 || _.trim(e.target.value).length <= 0) {
			setInvalidValidation(true);
			props.setEmptyDomain(props.id, true);
		} else {
			props.setEmptyDomain(props.id, false);
			const validMessage = isValidDomainName(e.target.value.toLowerCase());
			if (validMessage !== '') {
				setInvalidValidation(true);
			} else {
				setInvalidValidation(false);
			}
		}
		setDomainName(_.trim(e.target.value.toLowerCase()));
	};

	useEffect(() => {
		if (domainName === '' && props.isOld) {
			const thisDomain = domains.find((d) => d.id === props.id); // Vipul - get list from parent
			!_.isUndefined(thisDomain) ? setDomainName(thisDomain.domainName) : setDomainName('');
		}
	}, []);

	useEffect(() => {
		const showValidationError = invalidValidation || duplicateValidation;
		if (showValidationError !== showNameValidation) {
			setShowNameValidation(showValidationError);
		}
		props.updateDomainValidation(props.id, !showValidationError);
	}, [invalidValidation, duplicateValidation]);

	useEffect(() => {
		let filteredList = props.domainList.filter((el) => el.id !== props.id);
		let defected = filteredList.some((el) => (el.isEmpty === true && !el.isValidDomain) || el.isDuplicate == true);

		if (defected) {
			setIsDisabled(true);
		} else setIsDisabled(false);
	}, [props.domainList]);

	const onOpen = () => {
		if (domainName === '') {
			setDomainName('@');
		}
	};

	useEffect(() => {
		if (props.domainError === true && domainName === '') {
			setShowNameValidation(true);
		}
	}, [props.domainError]);

	const isValidDomainName = (currval) => {
		let msg = '';
		const domainParts = currval.split('.');

		if (domainParts.length < 2) {
			msg = 'Atleast one dot required';
			return msg;
		}

		const wildcardReg = new RegExp(/(^(@\*)([A-Za-z0-9]{1,63})*$)|^(@{1,1})([A-Za-z0-9]{1,63})$/);
		const onlyWildcardReg = new RegExp(/^(@\*)$/);
		if (onlyWildcardReg.test(domainParts[0]) && domainParts.length < 3) {
			msg = 'If first part is a wild card, then it must have 2 or more part followed';
			return msg;
		}

		const generalReg = new RegExp(/^[A-Za-z0-9]{1,63}$/);

		if (!wildcardReg.test(domainParts[0])) {
			msg = 'First part can be * or alphanumeric, other special chars not allowed';
			return msg;
		}

		for (var i = 1; i < domainParts.length; i++) {
			if (!generalReg.test(domainParts[i])) {
				msg = 'Special chars not allowed, subdomain lenght must be 1-63!';
				break;
			}
		}
		return msg;
	};

	useEffect(() => {
		checkDuplicate(domainName, true);
	}, [domains]);

	const checkDuplicate = (e, isEffect) => {
		let found = false;
		if (domainName !== '') {
			if (isEffect) {
				found = domains.some((el) => el.domainName === e.toLowerCase() && el.id !== props.id);
			} else found = domains.some((el) => el.domainName === e.target.value.toLowerCase() && el.id !== props.id);
		}

		if (found) {
			setDuplicateValidation(true);
			props.setDomainDuplicate(props.id, true);
		} else {
			setDuplicateValidation(false);
			props.setDomainDuplicate(props.id, false);
		}
	};

	const getValidationErrorMessage = () => {
		if (duplicateValidation) {
			return labels.duplicateDomain;
		}

		if (invalidValidation) {
			const domainNamePart = _.trimStart(domainName, '@');
			return !domainNamePart ? labels.required : labels.invalidDomainName;
		}

		if (showNameValidation) {
			return labels.required;
		}

		return '';
	};

	const renderRemoveDomainBtn = () => {
		const propsBtn = {
			svg: IconoirXmarkCircle,
			iconSize: 20,
			variant: 'text',
			title: labels.remove,
			onClick: () => {
				props.remove(props.id);
			}
		};
		return <Button {...propsBtn} />;
	};

	return (
		<StyledDomainContainer className="add-new-domain-wrap" id={props.id}>
			<div className="group-input-textbox">
				<Input
					id={props.id}
					label={labels.domainName}
					maxLength="100"
					value={domainName}
					errorMessage={showNameValidation ? getValidationErrorMessage() : null}
					onFocus={onOpen}
					clearButtonTitle={labels.clearAllValues}
					onChange={(e) => {
						onInputChange(e);
						props.updateDomainName(props.id, e.target.value);
						checkDuplicate(e, false);
					}}
					disabled={isDisabled}
				/>
			</div>
			<span>{renderRemoveDomainBtn()}</span>
		</StyledDomainContainer>
	);
};

export default AddNewDomain;

const StyledDomainContainer = styled.section`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	width: 35rem;
	position: relative;
	gap: var(--spacing-medium);
	.group-input-textbox {
		width: 30rem;
		.motif-label-for-text {
			top: 1.5rem;
		}
		.motif-input-clear-button {
			top: 1.5rem;
			&:hover,
			&:focus {
				box-shadow: none !important;
			}
		}
		svg {
			&.small {
				width: 2rem;
				height: 2rem;
				max-width: 2rem;
				max-height: 2rem;
			}
		}
	}
	.clearall {
		margin: 0 1.5rem;
		height: 4.4rem;
		display: flex;
		align-items: center;
		svg {
			fill: ${(props) => props.theme.color[`black`]};
		}
	}
`;
